// src/utils/getSignedUrl.js
const MEDIA_WORKER_URL = process.env.REACT_APP_MEDIA_WORKER_URL || 'https://media.tempostock.com/generate-signed-url';

// Separate caches for different expiration times
const signedUrlCaches = {
  default: {}, // 5 min cache
  meta: {}, // 1 hour cache
  social: {} // 24 hour cache
};

export const getSignedUrl = async (filePath, expirationSeconds = 300) => {
  // Choose the appropriate cache based on expiration time
  let cacheKey = 'default';
  if (expirationSeconds >= 86400) {
    cacheKey = 'social';
  } else if (expirationSeconds >= 3600) {
    cacheKey = 'meta';
  }

  // Check cache
  const cachedEntry = signedUrlCaches[cacheKey][filePath];
  if (cachedEntry && Date.now() < cachedEntry.expiresAt) {
    console.log(`Cache hit for filePath: ${filePath} in ${cacheKey} cache`);
    return cachedEntry.url;
  } else if (cachedEntry) {
    // Cache entry exists but has expired
    console.log(`Cache expired for filePath: ${filePath} in ${cacheKey} cache. Deleting.`);
    delete signedUrlCaches[cacheKey][filePath];
  }

  try {
    console.log(`Requesting signed URL for filePath: ${filePath} with expiration: ${expirationSeconds}s`);
    const response = await fetch(MEDIA_WORKER_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        filePath,
        expirationSeconds 
      }),
    });

    console.log(`Media Worker response status: ${response.status}`);
    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Failed to get signed URL: ${errorText}`);
      return null;
    }

    const data = await response.json();
    
    // Store the URL along with its expiration time (with a 60-second buffer for safety)
    // Assumes the generated URL is valid for the requested expirationSeconds from now.
    signedUrlCaches[cacheKey][filePath] = {
      url: data.signedUrl,
      expiresAt: Date.now() + (expirationSeconds * 1000) - (60 * 1000) 
    };
    
    console.log(`Generated signed URL for: ${filePath} (URL hidden)`);
    return data.signedUrl;
  } catch (error) {
    console.error('Error fetching signed URL:', error);
    return null;
  }
};